module.exports = __webpack_public_path__ + "img/d1ec1ca540684fcbbfe49b63992e434c.112a14d5.png";